import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import React from "react";

import ViaroInput from "./viaro-input";
import ViaroModal from "./viaro-modal";
export default function Buyerdetails({modal,  setModal, editUserInfo, userdata, setUserData}:{modal:any,  setModal:any, editUserInfo:()=>void, userdata:any, setUserData:any}) {
  return (
    <ViaroModal
      status={modal}
      title="მყიდველის დეტალები"
      maxWidth="xs"
      setClose={() => setModal({status:false, currentUserId:'', offerId:''})}
    >
      <Box mb={0.5}>
        <ViaroInput
          setEditInfo={setUserData}
          label="სახელი"
          idvalue="name"
          defaultValue={userdata.name}
          isEditable={true}
        />
      </Box>
      <Box mb={0.5}>
        <ViaroInput
          setEditInfo={setUserData}
          label="გვარი"
          idvalue="surname"
          defaultValue={userdata.surname}
          isEditable={true}
        />
      </Box>
      <Box mb={0.5}>
        <ViaroInput
          setEditInfo={setUserData}
          label="ტელეფონის  ნომერი"
          idvalue="phone"
          defaultValue={userdata.mobile}
        />
      </Box>
      <Box mb={0.5}>
        <ViaroInput
          setEditInfo={setUserData}
          label="მისამართი"
          idvalue="address"
          defaultValue={userdata.address}
          isEditable={false}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: "#ffffff",
          display: "flex",
          justifyContent: "center",
          py: 2,
        }}
      >
        <LoadingButton
          onClick={editUserInfo}
          sx={{
            backgroundColor: "#D9D9D9",
            color: "#000",
            border: "1px solid #000",
            py: 1.5,
            px: 10,
          }}
          variant="outlined"
        >
          რედაქტირება
        </LoadingButton>
      </Box>
    </ViaroModal>
  );
}
